import { ReactComponent as IconChevronDown } from "@/assets/svgs/chevron-down.svg";
import { ReactComponent as IconChevronRight } from "@/assets/svgs/chevron-right.svg";
import { ReactComponent as IconInformation } from "@/assets/svgs/i.svg";
import { ReactComponent as IconClose } from "@/assets/svgs/icon-close.svg";
import { ReactComponent as IconDataRequests } from "@/assets/svgs/icon-data-requests.svg";
import Button from "@/components/Button";
import CardConfigure from "@/componentsDS/Modal/CardConfigure";
import Modal from "@/componentsDS/Modal/Modal";
import Portal from "@/components/Portal";
import Tabs, { Tab } from "@/components/Tabs";
import Toast from "@/components/Toast";
import { EnrolmentTypes } from "@/constants/use-case/enrolment";
import useModal from "@/hooks/use-modal";
import usePage from "@/hooks/use-page";
import useRequests from "@/hooks/use-requests/index";
import useToast from "@/hooks/use-toast";
import { useNavigate, useParams, useQuery } from "@/lib/router-dom/index";
import API_DATA_ELEMENTS_REQUEST from "@/services/api/dataElementsEnrolment";
import handleSubPrincipals from "@/utils/handle-subscriptionPrincipal";
import rem from "@/utils/rem";
import titleCase from "@/utils/title-case";
import { getUseCaseId } from "@/utils/use-case-storage";
import moment from "moment";
import { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import Loader from 'react-loader-spinner';
import MultiClamp from "react-multi-clamp";
import Tags from '@/componentsDS/Tags/Tags';
import Breadcrumbs from "@/componentsDS/Breadcrumbs/index";


const Page = () => {
	/*=================================================
		General
	/================================================*/

	const { useCaseId } = useParams();
	const useCase = useMemo(() => getUseCaseId(useCaseId), [useCaseId]);

	const response = sessionStorage.getItem("acceptedResponse");

	const { t } = useTranslation();

	const statuses = {
		approved: "APPROVED",
		rejected: "REJECTED",
		revoked: "REVOKED",
		pending: "PENDING",
	};

	const requestTypes = {
		review: "REVIEW",
		request: "REQUEST",
	};

	const toastType = {
		success: "success",
		error: "error",
	};

	const [pageTitle, setPageTitle] = useState("Data Requests");

	const { breadcrumbsItems } = usePage({
		title: pageTitle,
		breadcrumbs: [
			{
				label:'',
				link:'/'
			},
			{
				label:'Use Cases',
				link:'/use-cases/enrolment'
			},
			{
				label: useCase?.name,
				link: `/use-cases/${useCaseId}/dashboard`
			},
			{
				label: pageTitle,
				link: ``
			},
		],
	});
	const { goTo } = useNavigate();

	const searchParams = useQuery();
	const page = searchParams.get('page')
	const type = searchParams.get('type')

	const pageLimit = 10;
	const [currentPage, setCurrentPage] = useState(page ?? 1);

	const [requestType, setRequestType] = useState();
	const [reviewLabel, setReviewLabel] = useState("For Review");
	const [requestLabel, setRequestLabel] = useState("My Requests");

	/*=================================================
		API
	/================================================*/

	const { toastList, addToastMessage } = useToast();

	const {
		items: reviewItems,
		setItems: setReviewItems,
		fetch: fetchReview,
		meta: reviewMeta,
		error: errorReview,
		currentItem,
		setCurrentItem,
		loading: loadingReview,
	} = useRequests([]);
	const {
		items: requestItems,
		setItems: setRequestItems,
		fetch: fetchRequest,
		meta: requestMeta,
		error: errorRequest,
		loading: loadingRequest,
	} = useRequests([]);

	function fetchHandler(type) {
		const getAllReview = {
			// status: statuses.pending,
			isRequester: false,
		};

		const getAllRequests = {
			isRequester: true,
		};

		let payload = {
			pageSize: pageLimit,
			orderBy: sortConfig.direction === true ? "ASC" : "DESC",
			sortBy: sortConfig.key,
			currentPage: currentPage,
		};

		if (useCaseId) {
			payload = {
				...payload,
				useCaseId: useCaseId,
			};
		}

		if (type === requestTypes.review) {
			payload = {
				...payload,
				...getAllReview,
			};

			return fetchReview(payload);
		}

		if (type === requestTypes.request) {
			payload = {
				...payload,
				...getAllRequests,
			};

			return fetchRequest(payload);
		}
	}

	useEffect(() => {
		addToastMessage(errorReview, toastType.error);
	}, [errorReview]);

	useEffect(() => {
		addToastMessage(errorRequest, toastType.error);
	}, [errorRequest]);

	useEffect(() => {
		let request;
		if (response === statuses.approved) {
			request = "You have successfully approved the request.";
		} else if (response === statuses.rejected) {
			request = "You have successfully rejected the request.";
		}
		sessionStorage.removeItem("acceptedResponse");

		addToastMessage(request, toastType.success);
	}, [response]);

	/*=================================================
		Tabs
	/================================================*/

	const [tabsItems, setTabsItems] = useState([
		{ label: reviewLabel, active: (type && type === requestTypes.review) ?? true, options: ["review"] },
		{ label: requestLabel, active: (type && type === requestTypes.request) ?? false, options: ["requests"] },
	]);

	function selectTab(index) {
		const items = [...tabsItems].map((item) => ({
			...item,
			active: false,
		}));

		items[index].active = true;

		setCurrentPage(1);
		setTabsItems(items);
	}

	/*=================================================
		Sort
	/================================================*/

	const [sortConfig, setSortConfig] = useState({
		key: "createdAt",
		direction: false,
	});

	function handleSort(key, type) {
		let direction = sortConfig.direction;
		if (sortConfig.key === key) {
			direction = !direction;
		} else {
			direction = true;
		}

		const sortDirection = direction === true ? "asc" : "desc";

		setSortConfig({ key, direction });
	}

	/*=================================================
		Paginate
	/================================================*/

	useEffect(() => {
		if (tabsItems[0].active === true) {
			fetchHandler(requestTypes.review);
		}

		if (tabsItems[1].active === true) {
			fetchHandler(requestTypes.request);
		}
	}, [currentPage, tabsItems, sortConfig]);

	// useEffect(()=> {
	// 	if(currentPage > meta?.totalPages){
	// 		setCurrentPage(meta?.totalPages || 1)
	// 	}
	// }, [items])

	/*=================================================
		Data Table
	/================================================*/

	const DataTable = ({ itemData, meta, type }) => {
		function goToPrev() {
			if (currentPage === 1) {
				return;
			}

			setCurrentPage((prev) => prev - 1);
		}

		function goToNext() {
			if (currentPage === meta?.totalPages) {
				return;
			}

			setCurrentPage((prev) => prev + 1);
		}

		function getClassName(name) {
			if (!sortConfig) {
				return;
			}
			return sortConfig.key === name
				? sortConfig.direction === true
					? "is-asc"
					: "is-desc"
				: "";
		}

		function getTypeName(type) {
			if (type === statuses.pending) {
				return "In Progress";
			}

			if (type === statuses.approved) {
				return "Approved";
			}

			if (type === statuses.rejected) {
				return "Rejected";
			}

			if (type === statuses.revoked) {
				return "Revoked";
			}
		}

		function statusTag(status) {
			const statusText = getTypeName(status);
			return (
				<>
					{status === statuses.approved && <Tags label={statusText} tagClassName="DS__tag--success" />}
					{(status === statuses.rejected || status === statuses.revoked) && <Tags label={statusText} tagClassName="DS__tag--critical" />}
					{status ===  statuses.pending && <Tags label={statusText} tagClassName="DS__tag--warning" />}

				</>
			)
		}

		function getContributeToName(type) {
			switch (type) {
				case EnrolmentTypes.provider:
					return "Contribute";
				case EnrolmentTypes.consumer:
					return "Consume";
				case EnrolmentTypes.provideOnBehalf:
					return "Provide on behalf of";
				case EnrolmentTypes.consumeOnBehalf:
					return "Consume on behalf of";
				case EnrolmentTypes.consumeOnBehalfOfPrincipal:
					return "Consume on behalf of (Principal)"
				case EnrolmentTypes.provideOnBehalfOfPrincipal:
					return "Provide on behalf of (Principal)"
				default:
					return "";
			}
		}

		const list = itemData.map((item, index) => {
			let status = item.status;
			if (item?.participant?.subscriptionPrincipals?.length) {
				if (item?.participant?.subscriptionPrincipals?.some((p) => p?.status === "PENDING")) {
					status = statuses.pending;
				} else if (item?.participant?.subscriptionPrincipals?.every((p) => p?.status === statuses.approved)) {
					status = statuses.approved;
				} else if (item?.participant?.subscriptionPrincipals?.every((p) => p?.status === statuses.rejected)) {
					status = statuses.rejected;
				} else if (item?.participant?.subscriptionPrincipals?.every((p) => p?.status === statuses.revoked)) {
					status = statuses.revoked;
				}
			}

			return (
				<div className="data-table__table__body__row" key={index}>
					<div className="data-table__table__body__content data-table__table__body__content--text data-table__table__body__content--break">
						{moment(item?.created).format("DD/MM/YYYY h:mma")}
					</div>
					<div className="data-table__table__body__content data-table__table__body__content--text data-table__table__body__content--heavy data-table__table__body__content--break">
						{item?.dataElement?.elementName}
					</div>
					<div className="data-table__table__body__content data-table__table__body__content--text data-table__table__body__content--break">
						{item?.participant?.name}
					</div>
					<div className="data-table__table__body__content data-table__table__body__content--text">
						{getContributeToName(item?.type)}
					</div>
					<div className="data-table__table__body__content data-table__table__body__content--text">
						<MultiClamp clamp={1}>
							{item?.useCase?.useCaseTitle}
						</MultiClamp>
					</div>

					{
						<div className="data-table__table__body__content data-table__table__body__content__button data-table__table__body__content--flex-end">
							{(type === requestTypes.review && status === statuses.pending) &&
								(
									<>
										<Button
											text="Approve"
											submit={() => {
												setRequestType(statuses.approved);
												showConfirmation();
												setCurrentItem(item);
											}}
										/>
										<Button
											text="Reject"
											ghost
											submit={() => {
												setRequestType(statuses.rejected);
												showConfirmation();
												setCurrentItem(item);
											}}
										/>
									</>
								)
							}
							{(
								type === requestTypes.review &&
								status !== statuses.pending
							) && (
									<>
										{statusTag(status)}
									</>
								)}
							{type === requestTypes.request && (
								<>
									{statusTag(status)}
								</>
							)}

							<span
								data-testid="view-btn"
								className="data-table__table__body__content__action link"
								onClick={() => {
									handleDataRequestView(item, type);
								}}
								tabIndex={0}
								onKeyPress={() => {
									handleDataRequestView(item, type);
								}}
							>
								<IconChevronRight />
							</span>
						</div>
					}
				</div>
			);
		});

		function getPageStart(pageSize, pageNr) {
			return pageSize * pageNr;
		}

		function getPageLabel(total, pageSize, pageNr) {
			const start = Math.max(getPageStart(pageSize, pageNr), 0);
			const end = Math.min(getPageStart(pageSize, pageNr + 1), total);

			return `${start + 1} - ${end}`;
		}

		function handleCurrnetInput(e) {
			const value = e.target?.value === "" ? 1 : e.target.value;
			const current = parseInt(value);

			if (current < 1) {
				return setCurrentPage(1);
			}

			if (current > meta.pageCount) {
				return setCurrentPage(meta.pageCount);
			}

			setCurrentPage(current);
		}

		const NoMessage = () => {
			return (
				<div className="data-table__empty__icon">
					<IconDataRequests />
					<span>There are no requests to be shown.</span>
				</div>
			);
		};

		return (
			<div className="data-table__content">
				<div className="data-table__content__cols">
					<div className="data-table__content__col">
						<div className="data-table__table">
							<div className="data-table__table__head">
								<div className="data-table__table__head__row">
									<div
										className={`data-table__table__head__title data-table__table__head__title__sort-order link ${getClassName(
											"createdAt"
										)}`}
										id="createdAt"
										onClick={(e) => {
											handleSort("createdAt");
										}}
										tabIndex={0}
										onKeyPress={(e) => {
											handleSort("createdAt");
										}}
									>
										Date/Time{" "}
										<span className="data-table__table__head__icon__sort-order"></span>
									</div>
									<div
										className={`data-table__table__head__title data-table__table__head__title__sort-order link ${getClassName(
											"dataElementId"
										)}`}
										id="dataElementId"
										onClick={(e) => {
											handleSort("dataElementId");
										}}
										tabIndex={0}
										onKeyPress={(e) => {
											handleSort("dataElementId");
										}}
									>
										Data Element{" "}
										<span className="data-table__table__head__icon__sort-order"></span>
									</div>
									<div
										className={`data-table__table__head__title data-table__table__head__title__sort-order link ${getClassName(
											"organization"
										)}`}
										id="organization"
										onClick={(e) => {
											handleSort("organization");
										}}
										tabIndex={0}
										onKeyPress={(e) => {
											handleSort("organization");
										}}
									>
										{type === requestTypes.review && (
											<>Requester</>
										)}
										{type === requestTypes.request && (
											<>Request sent to</>
										)}{" "}
										<span className="data-table__table__head__icon__sort-order"></span>
									</div>
									<div
										className={`data-table__table__head__title data-table__table__head__title__sort-order link ${getClassName(
											"type"
										)}`}
										id="type"
										onClick={(e) => {
											handleSort("type");
										}}
										tabIndex={0}
										onKeyPress={(e) => {
											handleSort("type");
										}}
									>
										{type === requestTypes.review && (
											<>Request you to</>
										)}
										{type === requestTypes.request && (
											<>Request to</>
										)}{" "}

										<span className="data-table__table__head__icon__sort-order"></span>
									</div>
									<div
										className={`data-table__table__head__title data-table__table__head__title__sort-order link ${getClassName(
											"dataElementId"
										)}`}
										id="dataElementId"
										onClick={(e) => {
											handleSort("dataElementId");
										}}
										tabIndex={0}
										onKeyPress={(e) => {
											handleSort("dataElementId");
										}}
									>
										Use Case{" "}
										<span className="data-table__table__head__icon__sort-order"></span>
									</div>
									<div className="data-table__table__head__title data-table__table__head__title--flex-end"></div>
								</div>
							</div>
							{loadingReview || loadingRequest ? (
								<div className="data-table__empty">
									<Loader
										className="loadingSpinner__position__center"
										data-testid="loadingSpinner__position__center"
										type="ThreeDots"
										color="purple"
										height={10}
										width={15}
									/>
								</div>
							) : (
								<>
									<div className="data-table__table__body">
										{list.length > 0 ? (
											list
										) : (
											<div className="data-table__empty">
												<NoMessage />
											</div>
										)}
									</div>
									{list.length > 0 && (
										<div className="data-table__table__footer">
											<div className="data-table__table__footer__row">
												<div className="data-table__table__footer__row__left">
													<div className="data-table__table__pagination">
														<input
															data-testid="pagination-input"
															className="data-table__table__pagination__page"
															type="number"
															value={currentPage}
															onChange={(e) =>
																handleCurrnetInput(e)
															}
															min="1"
														/>
														<span className="data-table__table__pagination__page__meta">
															{" "}
															of {meta?.pageCount ||
																1}{" "}
															pages{" "}
														</span>
														<button
															data-testid="pagination-prev"
															className="data-table__table__pagination__prev"
															onClick={() => goToPrev()}
															disabled={currentPage === 1}
														>
															<IconChevronDown />
														</button>
														<button
															data-testid="pagination-next"
															className="data-table__table__pagination__next"
															onClick={() => goToNext()}
															disabled={
																currentPage ===
																meta?.pageCount
															}
														>
															<IconChevronDown />
														</button>
													</div>
												</div>
												<div className="data-table__table__footer__row__right">
													<div className="data-table__table__meta">
														Showing{" "}
														{getPageLabel(
															meta?.count,
															pageLimit,
															currentPage - 1
														)}{" "}
														of {meta?.count || 0} entries
													</div>
												</div>
											</div>
										</div>
									)}
								</>
							)}
						</div>
					</div>
				</div>
			</div >
		);
	};

	/*=================================================
		Modal
	/================================================*/

	const {
		visible: visibleConfirmation,
		show: showConfirmation,
		hide: hideConfirmation,
	} = useModal();

	/*=================================================
		API Action Functions
	/================================================*/
	async function requestAction() {
		let approvedAllSubPrincipal = handleSubPrincipals(currentItem, statuses.approved)
		let rejectAllSubPrincipal = handleSubPrincipals(currentItem, statuses.rejected)

		let payload = {
			type: currentItem.type,
			organizationId: currentItem.organizationId,
			dataElementId: currentItem.dataElementId,
			useCaseId: currentItem.useCaseId,
		};

		if (requestType === statuses.approved) {
			payload.subscriptionPrincipals = approvedAllSubPrincipal;
		}

		if (requestType === statuses.rejected) {
			payload.subscriptionPrincipals = rejectAllSubPrincipal;
		}

		const [error] = await API_DATA_ELEMENTS_REQUEST.update(
			requestType,
			payload
		);

		if (error) {
			return addToastMessage(error?.message, toastType.error);
		}

		const request =
			requestType === statuses.approved
				? "successfully accepted"
				: "rejected";
		addToastMessage(
			`You have ${request} the data request.`,
			toastType.success
		);

		fetchHandler(requestTypes.review);
	}

	/*=================================================
		Routes
	/================================================*/

	function handleDataRequestView(item, type) {
		const obj = {
			data: item,
			requestType: type,
		};

		if (typeof useCaseId !== "undefined") {
			goTo(`/use-cases/${useCaseId}/${type.toLowerCase()}/view`, {
				state: obj,
			});
		} else {
			goTo(`/dashboard/${type.toLowerCase()}/view`, { state: obj });
		}
	}

	return (
		<>
			<Breadcrumbs breadcrumbItems={breadcrumbsItems} />

			<div className="title-header">
				<div className="title-header__left">
					<div className="title-header__title">{pageTitle}</div>
				</div>

				<div className="title-header__right"></div>
			</div>

			<Tabs addClass="tabs--horizontal-rule">
				{tabsItems.map((item, index) => (
					<Tab
						key={index}
						label={item?.label}
						active={item?.active}
						onClick={() => selectTab(index)}
					/>
				))}
			</Tabs>

			<div className="layout-data-elements--full-width">
				{tabsItems[0].active && (
					<DataTable
						itemData={reviewItems}
						meta={reviewMeta}
						type={requestTypes.review}
					/>
				)}

				{tabsItems[1].active && (
					<DataTable
						itemData={requestItems}
						meta={requestMeta}
						type={requestTypes.request}
					/>
				)}
			</div>

			<Modal visible={visibleConfirmation} variant="medium" close={hideConfirmation}>
				<CardConfigure>
					<CardConfigure.Header>
						<CardConfigure.Header.Title>
							<div className="card-configure__header__left">
								<div className="card-configure__title">
									<div className="card-configure__title__left">
										<IconInformation />
									</div>
									<div className="card-configure__title__right">
										<div className="card-configure__title__right__top">
											{titleCase(requestType)} Request
										</div>
									</div>
								</div>
							</div>
						</CardConfigure.Header.Title>
					</CardConfigure.Header>
					<CardConfigure.Body>
						<CardConfigure.Body.Col>
							{requestType === statuses.approved && (
								<>
									<div
										style={{
											fontSize: rem(14),
											textAlign: "center",
										}}
									>
										Are you sure you want to approve this
										request?
									</div>
								</>
							)}
							{requestType === statuses.rejected && (
								<>
									<div
										style={{
											fontSize: rem(14),
											textAlign: "center",
										}}
									>
										Are you sure you want to reject this
										request? You will not be able to
										exchange this data element with this
										participant until another request is
										sent.
									</div>
								</>
							)}
						</CardConfigure.Body.Col>
					</CardConfigure.Body>
					<CardConfigure.Footer>
						<CardConfigure.Footer.Right>
							<Button
								ghost
								text="Yes"
								submit={() => {
									hideConfirmation();
									requestAction();
								}}
								data-testid="btnsubmit"
							/>

							<span
								style={{
									width: rem(10),
									display: "inline-block",
								}}
							></span>

							<Button
								text="No"
								submit={() => {
									hideConfirmation();
								}}
								data-testid="btnNo"
							/>
						</CardConfigure.Footer.Right>
					</CardConfigure.Footer>
				</CardConfigure>
			</Modal>

			<Toast toastList={toastList} />
		</>
	);
};

export default Page;
